import React from 'react'



const InfoRow = ({ label, value }) => (
    <div className="flex justify-between items-center max-w-[300px] mx-auto">
        <span className="font-medium text-sm">{label}:</span>
        <span className="text-xs text-gray-600">{value || 'N/A'}</span>
    </div>
);

const UboInfo = ({ data }) => {
    const uboInformation = data?.uboInformation || []
    return (
        <div> <div className="p-4 space-y-6">
            {uboInformation.length === 0 ? (
                <p className="text-center text-gray-500">No UBO Information Available</p>
            ) : (
                uboInformation.map((ubo, index) => (
                    <div key={ubo._id} className="border p-4 rounded-lg shadow-sm bg-white">
                        <h2 className="text-md font-semibold mb-4">UBO #{index + 1}</h2>
                        <InfoRow label="First Name" value={ubo.firstName} />
                        <InfoRow label="Last Name" value={ubo.lastName} />
                        <InfoRow label="Email" value={ubo.email} />
                        <InfoRow label="DOB" value={ubo.dob} />
                        <InfoRow label="Identification Number" value={ubo.identificationNumber} />
                        <InfoRow label="Country" value={ubo.country?.name} />
                        <InfoRow label="Document Type" value={ubo.documentType} />
                        <InfoRow label="Document Name" value={ubo.documentName} />
                        <div className="flex flex-col gap-2 mt-2">
                            {ubo.documentFrontImage && (
                                <a
                                    href={ubo.documentFrontImage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 text-sm underline"
                                >
                                    View Document Front
                                </a>
                            )}
                            {ubo.documentBackImage && (
                                <a
                                    href={ubo.documentBackImage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-500 text-sm underline"
                                >
                                    View Document Back
                                </a>
                            )}
                        </div>
                        <div className="mt-4">
                            <h3 className="text-sm font-semibold mb-2">Address</h3>
                            <InfoRow label="Address Line 1" value={ubo.address?.addressLine1} />
                            <InfoRow label="City" value={ubo.address?.city} />
                            <InfoRow label="Region" value={ubo.address?.region} />
                            <InfoRow label="Zip Code" value={ubo.address?.zipCode} />
                            <InfoRow label="Country" value={ubo.address?.country?.name} />
                        </div>
                    </div>
                ))
            )}
        </div></div>
    )
}

export default UboInfo